import { Box, styled } from "@mui/material";

import { BasicButton } from "components/buttons/basic-button";

import { IAssistantLauncherProps } from "./types";

export const StyledAssistantLauncher = styled(Box, {
  shouldForwardProp: (prop) => prop !== "launcherPosition",
})<Pick<IAssistantLauncherProps, "launcherPosition">>(
  ({ theme, launcherPosition }) => ({
    position: "fixed",
    right: theme.spacing(4),
    bottom: theme.spacing(4),
    ...(launcherPosition && {
      left: launcherPosition.left,
      top: launcherPosition.top,
      right: "auto",
      bottom: "auto",
    }),
    zIndex: theme.zIndex.modal + 2,
  })
);

export const AssistantLauncherButton = styled(BasicButton, {
  shouldForwardProp: (prop) => prop !== "dragging",
})<Pick<IAssistantLauncherProps, "dragging">>(({ theme, dragging }) => ({
  cursor: dragging ? "grabbing" : "grab",
  touchAction: "none",
  userSelect: "none",
  width: theme.spacing(9),
  minWidth: theme.spacing(9),
  height: theme.spacing(9),
  padding: 0,
  borderRadius: theme.shape.borderRadius[5],
  boxShadow: theme.shadows[4],
  "&:focus-visible": {
    outline: `${theme.spacing(1)} solid ${theme.palette.primary.main}`,
    outlineOffset: theme.spacing(1),
  },
}));

export const AssistantNewBadge = styled("span")(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  transform: "translate(25%, -25%)",
  padding: theme.spacing(1, 2),
  border: `2px solid ${theme.palette.custom.semantic.surface.card}`,
  borderRadius: theme.shape.borderRadius[5],
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.custom.white,
  ...theme.typography.subtitle9,
  pointerEvents: "none",
}));
